import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { FormsModule, Validators } from '@angular/forms';
import { DynamicFieldModel, DynamicFormComponent } from '@share';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzInputModule } from 'ng-zorro-antd/input';
import { Group } from '@share';
import { DynamicTableComponent } from 'src/app/share/dynamic-table/dynamic-table.component';
import { HttpParams } from '@angular/common/http';
import { LoadingService } from 'src/app/share/services/loading.service';
import { GroupService } from './group.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-group',
  imports: [DynamicTableComponent, NzPopconfirmModule, NzInputModule, NzCardModule, NzTableModule, CommonModule, NzGridModule, FormsModule, NzButtonModule],
  providers: [NzModalService],
  templateUrl: './group.component.html',
  styleUrl: './group.component.scss'
})
export class GroupComponent implements OnInit {
  total = 0;
  list: any[] = [];
  schema = {
    name: "Group List",
    permissionKey: "group",
    enableDelete: true,
    enableEdit: true,
    enableAdd: true,
    size: "small",
    pageSize: 10,
    pageIndex: 1,
    sorts: {},
    columns: [
      {
        key: "serialNo",
        title: "No",
        type: "autoGenerate",
        width: "40px",
        isStickyRight:false,
        isStickyLeft:true,

      },
      {
        key: "group_name",
        title: "Name",
        type: "string",
        enableSearch: true,
        // searchType: "input",
        width: "200px",
        isStickyRight:false,
        isStickyLeft:false,
        searchType: "select",
        option: [] as any[],
      },
      {
        key: "action",
        title: "Actions",
        type: "button",
        width: "150px",
        isStickyRight:true,
        isStickyLeft:false,
        label: [{ name: "edit", type: "edit", isDanger: false, isEnable: true }, { name: "delete", type: "danger", isEnable: true }]//,{name:"delete",type:"danger"}
      }
    ]
  };

  fieldConfig: Array<DynamicFieldModel> = [
    {
      label: 'Group Name',
      name: 'name',
      type: 'input',
      placeholder: '',
      required: true,
      autofocus: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Name required',
        },
      ],
    },
    {
      label: 'id',
      name: 'id',
      type: 'hidden',
      placeholder: ''
    },
  ];
  width: string;
  constructor(private readonly modalService: NzModalService, private readonly loadingService: LoadingService, private readonly service: GroupService, private readonly cdr: ChangeDetectorRef) { }
  ngOnInit(): void {
    this.calculateWidth()
    
    forkJoin({
      groups: this.service.getItems()
    })
      .subscribe({
        next: ({ groups }) => {
          this.schema.columns[1].option = groups?.data.map((y: any) => ({
            text: y.group_name,
            value: y.group_name
          }));
        },
        error: err => console.error('Error loading group options:', err),
        complete: () => {
          let params = new HttpParams()
            .set('page', this.schema.pageIndex.toString())
            .set('pageSize', this.schema.pageSize.toString());
          this.loadData(params);
        }
      });
  }

  @HostListener('window:resize')
  calculateWidth() {
    const offsetWidth = 300;
    this.width = `${window.innerWidth - offsetWidth}px`;
  }

  change(data: { [key: string]: any }) {
    let params = new HttpParams()
      //.set('searchValue',this.searchValue)
      .set('page', data['pageIndex'].toString())
      .set('pageSize', data['pageSize'].toString())
      .set('filterValue', JSON.stringify(data['filters']))
      .set('sort', JSON.stringify(data['sorts']));
    this.loadData(params);
  }

  loadData(param: HttpParams = null) {
    this.loadingService.toggleTableLoading();
    this.cdr.detectChanges();
    this.service.getItems(param).subscribe({
      next: x => {
        this.list = x.data;
        this.total = x.total;
      },
      error: err => { this.loadingService.toggleTableLoading(); this.cdr.detectChanges(); },
      complete: () => { this.loadingService.toggleTableLoading(); this.cdr.detectChanges(); }
    });
  }

  formEvent(data: any) {
    if (data.id) {
      this.service.updateItem(data).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }
    else if (data.deleted_id) {
      this.modalService.confirm({
        nzTitle: 'Are you sure want to delete?',
        nzContent: 'This action cannot be undone.',
        nzOkText: 'Yes',
        nzCancelText: 'No',
        nzOnOk: () => {
          this.service.deleteItem(data).subscribe(x => {
            let params = new HttpParams()
              .set('page', this.schema.pageIndex.toString())
              .set('pageSize', this.schema.pageSize.toString());
            this.loadData(params);
          });
        },
        nzOnCancel: () => {

        }
      });

    }
    else {
      this.service.createItem(data).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }
  }
}
